export const css = {
	root: '_3roaVM8-',
	toolbar: '_13O9dJOm',
	alphabutton: '_1gN0RkPb',
	numberbutton: '_3wBfth8A',
	searchinput: 'liuuanVj',
	selectedbutton: '_26v8-AJY',
	invalidbutton: '_31eKQR9e',
	result: '_3QSATIcR',
	terms: '_2-EZ-T5v',
	term: '_3w1sLGUm',
	definition: 'GoWG-q6j',
	' _key': 'ascm-theme/ascm/glossary/glossary'
};

export default css;
